module.exports = __webpack_public_path__ + "img/overheads-product-development.a13485cb.svg";